var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ARROW_UP_KEY, ESCAPE_KEY } from '#constants';
import { IconButton } from '../../../../buttons';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../../icons';
import { useDatePickerContext } from '../../context/useDatePickerContext';
import { DatePickerTestIdFactory } from '../../interactions/DatePicker.interactions';
import styles from './CalendarHeader.module.css';
export const CalendarHeader = ({ 'data-testid': testId, }) => {
    _react_refresh_temp_2();
    const { dateWordings, focusedDate, id, onNextMonth, onPrevMonth, setIsCalendarOpen, wordings, } = useDatePickerContext();
    const currentYear = focusedDate.getFullYear();
    const currentMonthName = dateWordings.monthNames[focusedDate.getMonth()];
    const onKeyDownHeader = (event) => {
        const isDismissKey = event.key === ESCAPE_KEY ||
            (event.key === ARROW_UP_KEY && event.altKey);
        if (isDismissKey) {
            event.preventDefault();
            event.stopPropagation();
            setIsCalendarOpen(false);
        }
    };
    return (_jsxs("div", { className: styles.Container, "data-calendar-header": true, onKeyDown: onKeyDownHeader, children: [_jsx(IconButton, { "aria-label": wordings.prevMonthButtonAriaLabel, "data-testid": DatePickerTestIdFactory.getDatePickerPrevMonthButton(testId), Icon: ChevronLeftIcon, kind: "ghost", onClick: () => onPrevMonth(), size: "small" }), _jsx("h2", { className: styles.MonthYearLabel, color: "accent", "data-testid": DatePickerTestIdFactory.getDatePickerHeaderMonthAndYearTestId(testId), id: `${id}-calendar-header`, children: `${currentMonthName} ${currentYear}` }), _jsx(IconButton, { "aria-label": wordings.nextMonthButtonAriaLabel, "data-testid": DatePickerTestIdFactory.getDatePickerNextMonthButton(testId), Icon: ChevronRightIcon, kind: "ghost", onClick: () => {
                    onNextMonth();
                }, size: "small" })] }));
};
_react_refresh_temp_1 = CalendarHeader;
$RefreshReg$(_react_refresh_temp_1, "CalendarHeader");
_react_refresh_temp_2(CalendarHeader, "Smi6Z+Of7xSNaTTKYUOhlXb1m0k=", false, () => [useDatePickerContext]);
